export enum Flags {
  ShareViewCard = "QrHZ01Xi",
}

const params = new URLSearchParams(window.location.search);

export const FLAGS = new Set<Flags>(
  params.getAll("flags") as unknown as Flags[]
);
